'use client';
import { Capture } from './Capture';

function PageView() {
  return <Capture />;
}

export { PageView };
